import React from 'react';
import Button from '@material-ui/core/Button';
import CustomMuiLink from 'common/components/custom-mui-link/CustomMuiLink';

const UpLgNavItem: React.FC<IUpLgNavItemProps> = ({
  route,
  target,
  label,
  isReactLink,
  RouteLink,
  buttonProps,
}) => (
  <>
    {isReactLink ? (
      <RouteLink to={route}>
        <Button variant="text" color="primary" {...buttonProps}>
          {label}
        </Button>
      </RouteLink>
    ) : (
      <CustomMuiLink href={route} target={target}>
        <Button variant="text" color="primary" {...buttonProps}>
          {label}
        </Button>
      </CustomMuiLink>
    )}
  </>
);

export default UpLgNavItem;
